/* global mo, helper, L */

/* jQuery Top-Pagination */

/**
 *
 * Version: 1.0 (01.10.2013)
 * Requires: jQuery v1.8+
 *
 * Copyright (c) 2013 Artemeey
 * Under MIT and GPL licenses:
 *  http://www.opensource.org/licenses/mit-license.php
 *  http://www.gnu.org/licenses/gpl.html
 *
 * Специально для topvisor.ru
 */

pagination = {};
pagination.limits = [10,20,50,100];

pagination.add = function($table, load_function, limit){
	if($table.data('reload')) return; // виджет уже добавлен

	var o = {
		always_show:false
	};

	if(limit == undefined){
		if($.cookie('pagination_limit')){
			limit = $.cookie('pagination_limit');
		}else{
			limit = Math.floor($(window).height()/45);
			limit = Math.floor(limit/5)*5; // количество записей кратно 5
			if(limit < pagination.limits[0]) limit = pagination.limits[0];
		}
	}
	o.limit = limit;
	o.page = 1;

	o.$table = $table;
	o.$table.wrap('<div>');
	o.$table_wrap = $table.parent();
	o.$table.before(pagination.template);
	o.$table.after(pagination.template);

    o.$table.wrap('<div class="table_scroll_wrapper">');

	o.$thead = $('thead', o.$table);
	o.$tbody = $('tbody', o.$table);

	var n_td = $('thead th, thead td', o.$table).length;
	o.$tfoot = $('<tfoot class="hidden"><td colspan="'+n_td+'">'+L.Records_not_found+'</td></tfoot>');
	o.$tbody.after(o.$tfoot);

	o.$pagination = $('.pagination', o.$table_wrap);
	o.$prev = $('.prev', o.$pagination);
	o.$next = $('.next', o.$pagination);

	o.load_function = load_function;

	$('[name=page]', o.$pagination).change(function(){ pagination.load_function($(this).val(), o); });
	$('.prev, .next', o.$pagination).click(function(){
		if($(this).is('.disabled')) return false;

		var k = $(this).is('.next') ? 1 : -1 ;
		pagination.load_function(o.page+k, o);
		return false;
	});

	// количество записей на странице
	if(!$('[name=limit] option[value='+o.limit+']', o.$pagination).length){
		$('[name=limit]', o.$pagination).prepend('<option value="'+o.limit+'">'+o.limit+'</option>');
	}
	$('[name=limit]', o.$pagination).val(o.limit).trigger('change.design');
	$('[name=limit]', o.$pagination).change(function(){
		o.limit = $(this).val();
		pagination.load_function(o.page, o);

		// синхронизация полей выбора лимита
		$('[name=limit]', o.$pagination).val(o.limit).trigger('change.design');

		$.cookie('pagination_limit', o.limit);
	});

	// функции сортировки
	pagination.init_sort(o);

	pagination.load_function(o.page, o);

	// триггер reload
	o.$table.data('reload', function(){
		pagination.load_function(o.page, o);
	});
};

pagination.load_function = function(page, o){
	if(page) o.page = page*1;

	mo.preloader(true, o.$table_wrap);
	o.load_function(o);
};

pagination.after_load = function(data, o){
	var $sel_page = $('[name=page]', o.$pagination);
	$sel_page.empty();

	// перейти к первой странице, если открыта не первая и результатов нет
	if(!data.rows.length && o.page > 1){
		o.page = 1;
		pagination.load_function(o.page, o);

		return;
	}

	if(data.records == 0)
		o.$tfoot.insertAfter(o.$tbody).show();
	else
		o.$tfoot.appendTo($('body')).hide();

	if(data.total == 0) data.total = 1;

	if(data.total > 1 || o.always_show){
//	if(data.records > pagination.limits[0] || o.always_show){
		helper.generate_options($sel_page, data.total, o.page);
		$('.select .text', o.$pagination).text($sel_page.val());
		$('.of', o.$pagination).text('/ '+data.total);
        $(".records", o.$pagination).text("Записей: " + data.records + " шт.");
		$('[name=limit]', o.$pagination).trigger('change.design'); // обновить внешний вид селекта

		o.$pagination.show();

		// если панель была отабражена хотя бы раз, не прятать ее в текущей сессии
		o.always_show = true;
	}else{
		o.$pagination.hide();
	}

	pagination.after_render(data, o);
	mo.preloader(false, o.$table_wrap);
};

pagination.after_render = function(data, o){
	if(o.page > 1)
		o.$prev.removeClass('disabled');
	else
		o.$prev.addClass('disabled');

	if(o.page + 1 <= data.total)
		o.$next.removeClass('disabled');
	else
		o.$next.addClass('disabled');
};

pagination.init_sort = function(o){
	var id = o.$table.attr('id');

	if(!o.$table.data('sidx')){
		if(id)
			o.$table.data('sidx', $.cookie('pagination_'+id+'_sidx') || '');
		else
			o.$table.data('sidx', '');
	}
	if(!o.$table.data('sord')){
		if(id)
			o.$table.data('sord', $.cookie('pagination_'+id+'_sord') || '');
		else
			o.$table.data('sord', '');
	}

	$('th[data-sort], td[data-sort]', o.$thead).prepend('<div class="pagination-sorter"><span class="icons step1"><span class="icon1 icon-sort"></span><span class="icon2 icon-caret-up icon-sort-asc"></span><span class="icon3 icon-caret-down icon-sort-desc"></span></span></div>');

	// активная сортировка по умолчанию
	if(o.$table.data('sidx')){
		var step = (o.$table.data('sord') == 'ASC')?2:3;
		$('[data-sort="'+o.$table.data('sidx')+'"] .pagination-sorter .icons', o.$thead).removeClass('step1').addClass('step'+step);
	}

	$icons = $('.pagination-sorter .icons', o.$thead);
	$icons.click(function(){
		var name = $(this).closest('td, th').data('sort');
		o.$table.data('sidx', name);

		// убрать сортировку с других элементов
		$icons.removeClass('active');
		$(this).addClass('active');
		$icons.filter(':not(.active)').removeClass('step2 step3').addClass('step1');

		switch(true){
			case $(this).is('.step1'):
				$(this).removeClass('step1').addClass('step2');
				o.$table.data('sord', 'ASC');
				break;
			case $(this).is('.step2'):
				$(this).removeClass('step2').addClass('step3');
				o.$table.data('sord', 'DESC');
				break;
			case $(this).is('.step3'):
				$(this).removeClass('step3').addClass('step1');
				o.$table.data('sidx', '');
				o.$table.data('sord', '');
				break;
		}

		$.cookie('pagination_'+id+'_sidx', o.$table.data('sidx'));
		$.cookie('pagination_'+id+'_sord', o.$table.data('sord'));

		pagination.load_function(o.page, o);
	});
};

pagination.template = '<div class="pagination">'+
	'<a href="." class="icon-chevron-left prev disabled" title="Предыдущая страница"></a>'+
	'<a href="." class="icon-chevron-right next disabled" title="Следующая страница"></a>'+
	'<label class="select">'+
		'<span class="text"></span>'+
		'<span class="arrow icon-sort"></span>'+
		'<select name="page"><option value="1">1</option></select>'+
	'</label>'+
	'<span class="of"></span>'+
	'<span class="limit">'+L.PAGINATION_limit+
	'<label class="select">'+
		'<span class="text"></span>'+
		'<span class="arrow icon-sort"></span>'+
		'<select name="limit">'+
			'<option value="'+pagination.limits[0]+'">'+pagination.limits[0]+'</option>'+
			'<option value="'+pagination.limits[1]+'">'+pagination.limits[1]+'</option>'+
			'<option value="'+pagination.limits[2]+'">'+pagination.limits[2]+'</option>'+
			'<option value="'+pagination.limits[3]+'">'+pagination.limits[3]+'</option>'+
		'</select>'+
	'</label>' +
	'<span class="records"></span>'+
	'</span>'+
'</div>';